export default __webpack_public_path__ + "static/media/image-ph-health-briefing-w.b54c8e2b.png";